
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
export default {
  name: 'UISimpleProfileCard',
  components: { CloseIcon },
  props: {
    userProfile: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
